import { AddTransactionRequest } from "@syla/shared/types/requests/TransactionRequests";
import axios from "axios";

export const addOrder = async (order: AddTransactionRequest): Promise<void> => {
  await axios.post("/orders", order);
};
